import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IAcquaintanceType } from '../interfaces/IAcquaintanceType';

export async function fetchErknmAcquaintanceTypes(): Promise<IAcquaintanceType[]> {
  return apiGet<IAcquaintanceType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/erknm/acquaintance-types`,
  );
}

export async function fetchErknmAcquaintanceLackTypes(): Promise<IAcquaintanceType[]> {
  return apiGet<IAcquaintanceType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/erknm/acquaintance-lack-types`,
  );
}
